module.exports = __webpack_public_path__ + "static/media/giftsReceived_5000.a050532e.png";